import { defineStore } from "pinia";
import { computed, ref } from "vue";
export const useAuthStore = defineStore("auth", () => {
    // Memory-only — refresh token lives in HttpOnly cookie.
    const accessToken = ref(null);
    const user = ref(null);
    const isAuthenticated = computed(() => accessToken.value !== null);
    const isAdmin = computed(() => user.value?.is_admin === true);
    function setSession(token, u) {
        accessToken.value = token;
        user.value = u;
    }
    function setAccessToken(token) {
        accessToken.value = token;
    }
    function clear() {
        accessToken.value = null;
        user.value = null;
    }
    return { accessToken, user, isAuthenticated, isAdmin, setSession, setAccessToken, clear };
});
